import { useState } from 'react';

import { VStack, Text, Icon } from '@chakra-ui/react';
import { Form, Formik, FormikConfig, FormikValues } from 'formik';

import { ERROR_MESSAGE_USER_NOT_FOUND } from '@inspire/data/static/error-codes';
import {
  validateSchema,
  initFormikValuesFromSchema,
} from '@inspire/data/helpers/schemas';
import { SignupAccountSchema } from '@inspire/data/schemas/user/signup';
import Page from '@inspire/ui/chakra/layout/Page';
import { MailIcon } from '@inspire/ui/icons';
import { FormStack } from '@inspire/ui/chakra/forms/Form';

import Layout from 'components/layout/Layout';
import { OnlyLoggedOut } from 'components/auth/Redirects';
import SubmitButton from 'components/forms/SubmitButton';
import { handleErrors } from 'lib/errors';
import { useForgotPassword } from 'lib/hooks';
import { userNotFoundToast } from 'lib/toasts';
import { InputControl } from 'formik-chakra-ui';

const ForgotPasswordSchema = SignupAccountSchema.pick('email');

const MotDePasseOubliePage = () => {
  const [emailSent, setEmailSent] = useState(false);
  const { forgotPasswordAsync } = useForgotPassword();

  const formik: FormikConfig<FormikValues> = {
    initialValues: initFormikValuesFromSchema(ForgotPasswordSchema),
    validate: (values) => validateSchema(ForgotPasswordSchema, values),
    onSubmit: async (values) => {
      try {
        await forgotPasswordAsync(values.email);
        setEmailSent(true);
      } catch ({ errors }) {
        handleErrors(errors, [
          ERROR_MESSAGE_USER_NOT_FOUND,
          () => userNotFoundToast(),
        ]);
      }
    },
  };

  return (
    <Page title="Mot de passe oublié" withPanel headingIsTitle>
      {emailSent ? (
        <VStack>
          <Text textAlign="center" mt={0}>
            Un email t'a été envoyé pour réinitialiser ton mot de passe.
          </Text>
          <Icon as={MailIcon} boxSize={16} color="#444" />
        </VStack>
      ) : (
        <Formik {...formik}>
          <Form>
            <FormStack>
              <InputControl
                name="email"
                label="Adresse email"
                isRequired
                inputProps={{ type: 'email' }}
              />
              <SubmitButton loadingText="Réinitialisation en cours">
                Réinitialiser mon mot de passe
              </SubmitButton>
            </FormStack>
          </Form>
        </Formik>
      )}
    </Page>
  );
};

MotDePasseOubliePage.getWrappers = (page) => (
  <Layout rowVariant="yellow" containerWidth="sm" centerVertically>
    <OnlyLoggedOut>{page}</OnlyLoggedOut>
  </Layout>
);

export default MotDePasseOubliePage;
